// para obtener todos los clientes
export const GET_PAYMENT_SUCCESS = 'GET_PAYMENT_SUCCESS';
export const GET_PAYMENT_FAIL = 'GET_PAYMENT_FAIL';
// para obtener un cliente
export const GET_PAYMENT_SUCCESS_ID = 'GET_PAYMENT_SUCCESS_ID';
export const GET_PAYMENT_FAIL_ID = 'GET_PAYMENT_FAIL_ID';
// para obtener el beneficiario por busqueda    
export const GET_PAYMENT_SEARCH_SUCCESS = 'GET_PAYMENT_SEARCH_SUCCESS';
export const GET_PAYMENT_SEARCH_FAIL = 'GET_PAYMENT_SEARCH_FAIL';